module.exports = __webpack_public_path__ + "img/gpt-badge.d5c95e46.svg";